import React, { createContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

const AuthContext = createContext({})

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({})

  const contextValue = useMemo(
    () => ({
      auth,
      setAuth,
    }),
    [auth, setAuth],
  )

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  )
}
AuthProvider.propTypes = {
  children: PropTypes.node,
}

export default AuthContext
